import { useState } from "react";
import { SWIPE_THRESHOLD } from "../utils/constants";

export default function useTouchGestures(
  activeIndex,
  videosLength,
  goToNext,
  goToPrevious,
) {
  const [touchStart, setTouchStart] = useState(null);
  const [touchEnd, setTouchEnd] = useState(null);

  const handleTouchStart = (e) => {
    setTouchEnd(null);
    setTouchStart(e.targetTouches[0].clientX);
  };

  const handleTouchMove = (e) => {
    setTouchEnd(e.targetTouches[0].clientX);
  };

  const handleTouchEnd = () => {
    if (!touchStart || !touchEnd) return;

    const distance = touchStart - touchEnd;
    const isLeftSwipe = distance > SWIPE_THRESHOLD;
    const isRightSwipe = distance < -SWIPE_THRESHOLD;

    if (isLeftSwipe && activeIndex < videosLength - 1) {
      goToNext();
    }
    if (isRightSwipe && activeIndex > 0) {
      goToPrevious();
    }
  };

  return {
    handleTouchStart,
    handleTouchMove,
    handleTouchEnd,
  };
}
